import { combineReducers } from "redux";
import {
  ACTION_TYPE_FETCH_YEAR_SUMMARY_START,
  ACTION_TYPE_FETCH_YEAR_SUMMARY_END,
  ACTION_TYPE_FETCH_YEAR_SUMMARY_ERROR,
} from "../actions";

const yearSummary = (
  state = { loading: false, data: {}, error: undefined },
  action
) => {
  switch (action.type) {
    case ACTION_TYPE_FETCH_YEAR_SUMMARY_START:
      return { loading: true, data: {}, error: undefined };
    case ACTION_TYPE_FETCH_YEAR_SUMMARY_END:
      return { loading: false, data: action.data, error: undefined };
    case ACTION_TYPE_FETCH_YEAR_SUMMARY_ERROR:
      return { loading: false, data: {}, error: action.error };
    default:
      return state;
  }
};

export default combineReducers({ yearSummary });



// WEBPACK FOOTER //
// ./routes/home/reducers/index.js